import React, { type ReactElement } from 'react'
import { usePageContext } from 'vike-react/usePageContext'
import { Box } from '@chakra-ui/react'

function Link(props: {
  href: string
  className?: string
  children: React.ReactNode
  noHover: boolean
}): ReactElement {
  const { href, noHover, children, ...rest } = props
  const pageContext = usePageContext()
  const className = [
    props.className,
    pageContext.urlPathname === props.href && 'is-active'
  ]
    .filter(Boolean)
    .join(' ')
  return (
    <Box
      as="a"
      {...rest}
      className={className}
      href={href}
      sx={{
        fontWeight: '500',
        p: '3px 10px',
        display: 'flex',
        flexDir: 'column',
        justifyContent: 'center',
        '&:hover, &.navitem.is-active': noHover
          ? {}
          : {
              bg: 'yellow.300',
              position: 'relative',
              // color: 'white',
              '& .bend': {
                position: 'absolute',
                bg: 'white',
                bottom: '0px',
                right: '0px',
                borderStyle: 'solid',
                h: 'auto',
                aspectRatio: '1/1',
                w: '10px',
                boxShadow: '0px 2px 0px 0px white, 2px 0px 0px 0px white',
                zIndex: 2,
                overflow: 'hidden',
                '&:after': {
                  pointerEvents: 'none',
                  color: 'yellow.100',
                  background:
                    'linear-gradient(135deg, currentcolor calc(50% - 1px), rgba(232,232,232,1) 50%, rgba(255,255,255,0) 50.2%, rgba(255,255,255,0) 100%)',
                  content: '""',
                  display: 'block',
                  pos: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0
                },
                button: {
                  pos: 'absolute',
                  right: '20px',
                  bottom: '20px'
                }
              },
              svg: {
                fill: 'white'
              }
            }
      }}
    >
      {children}
      <div className="bend" />
    </Box>
  )
}

export { Link }
